import {TypeAheadOptionsProps} from "../props";
import React from "react";

export const TypeAheadOptions = (
  {filteredOptions, search, notFoundText, handleSuggestionClick}: TypeAheadOptionsProps
) => {
  if (!filteredOptions?.length) {
    return (
      <div key='no-results' className='typeahead-search__no-results'><p>{`"${search}" ${notFoundText}`}</p></div>);
  }
  const filtered = filteredOptions.map((suggestion, index) => (
    <div
      className='typeahead-search__suggestion'
      key={index}
      role="option"
      onClick={() => handleSuggestionClick(suggestion)}
      dangerouslySetInnerHTML={{
        __html: suggestion.replace(
          new RegExp(`(${search})`, 'gi'),
          '<strong>$1</strong>'
        ),
      }}
    />
  ));
  return (<>{filtered}</>);
}
